import React from 'react';
import LoginForm from './loginForm';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import * as adminActions from '../actions/admin';
import withRouter from '../utils/withRouter';

class LoginPage extends React.Component {

  constructor(props) {
    super(props);

    // set the initial component state
    this.state = {
      errors: {},
      user: {
        email: '',
        password: '',
        client: ''
      }
    };

    this.processForm = this.processForm.bind(this);
    this.forgotPassword = this.forgotPassword.bind(this);
    this.changeUser = this.changeUser.bind(this);

  }

  processForm(event) {
    // prevent default action. in this case, action is the form submission event
    event.preventDefault();
    //var that = this;

    this.props.actions.login(this.state.user.email,this.state.user.password,this.state.user.client)
    .then(res => { 
      if (res === 'success') {
        window.location.href = '/';
	    }
      else
          alert('login failed');
    })
    .catch(err =>{
        alert(err);
    })
  }

  componentDidMount() {
	  document.getElementsByTagName('body')[0].className = 'am-splash-screen';
  }

  componentWillUnmount() {
	  document.getElementsByTagName('body')[0].className = '';
  }


  changeUser(event) {
    const field = event.target.name;
    const user = this.state.user;
    user[field] = event.target.value;

    this.setState({
      user
    });
  }

  forgotPassword(event){
    event.preventDefault();
    this.props.navigate('/forgotPasswordPage');
  }
  
  render() {
    return (
      <LoginForm
        onSubmit={this.processForm}
        onForgotPassword={this.forgotPassword}
        onChange={this.changeUser}
        errors={this.state.errors}
        user={this.state.user}
      />
    );
  }

}


function mapStateToProps(state, ownProps) { 
    return {loggedIn: state.loggedIn}
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(adminActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginPage));